const config = {
    API_URL: "https://test.api.skynyx.ai/public/api",
    // API_URL: "http://127.0.0.1:8000/api",
    GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || "216515479927-bun13a401id2r4lolv9ot301j13jum30.apps.googleusercontent.com",
};

export default config;
